import { render, staticRenderFns } from "./BaseButtonContents.vue?vue&type=template&id=7dec411e&scoped=true"
import script from "./BaseButtonContents.vue?vue&type=script&lang=js"
export * from "./BaseButtonContents.vue?vue&type=script&lang=js"
import style0 from "./BaseButtonContents.vue?vue&type=style&index=0&id=7dec411e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dec411e",
  null
  
)

export default component.exports